export function noop() {
  return;
}
export function noopAndReturnArg(arg) {
  return arg;
}